module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clienttable"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.clients,
      "empty-text": "No Clients Found"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "name",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Address",
      "prop": "address",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Longitude",
      "prop": "longitude",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Latitude",
      "prop": "latitude",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Zoom",
      "prop": "zoom",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Sunset offset (minutes before)",
      "prop": "sunset_offset",
      "header-align": "center"
    }
  }), _vm._v(" "), (_vm.userIsSuperAdmin) ? _c('el-table-column', {
    attrs: {
      "label": "Operations",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('operations', {
          attrs: {
            "id": props.row.id
          },
          on: {
            "view": _vm.viewSites,
            "edit": function($event) {
              _vm.editClient(props.row)
            },
            "delete": _vm.deleteClient
          }
        })]
      }
    }])
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cead2ca","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Clients/ClientTable.vue
// module id = 976
// module chunks = 11